var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0405 10.2671C26.9367 10.2671 31.7329 15.0918 31.7329 21.063C31.7329 27.0341 26.9366 31.8579 21.0405 31.8579C15.1445 31.8578 10.3482 27.034 10.3481 21.063C10.3481 15.0919 15.1445 10.2672 21.0405 10.2671Z",
    stroke: "#222222",
    strokeWidth: 2.2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1.95556,
    height: 7.82226,
    transform: "matrix(0.704021 -0.710179 0.704021 0.710179 27.8682 29.2773)",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSearch);
export default __webpack_public_path__ + "static/media/ic_search.6dc12d27dab9590a1dec635b168c31bb.svg";
export { ForwardRef as ReactComponent };